// Import necessary Firebase modules
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  setPersistence, 
  browserSessionPersistence, 
  signInAnonymously 
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";


// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB4kkJxX_UbjVkwYkrDWgvYGmx2zgk1Ohc",
    authDomain: "gohost-b65d2.firebaseapp.com",
    projectId: "gohost-b65d2",
    storageBucket: "gohost-b65d2.firebasestorage.app",
    messagingSenderId: "579151142430",
    appId: "1:579151142430:web:cf95d47a119dd42db7180f",
    measurementId: "G-PDML43WBW1"
  };

// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
// Initialize Firebase Auth with session persistence for the web
const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    // console.log("Auth persistence set to browser session.");

    // Sign in anonymously
    return signInAnonymously(auth);
  })
  .then(() => {
    console.log("Signed in anonymously.");
  })
  .catch((error) => {
    console.error("Error during authentication setup: ", error);
  });

// Firestore setup
const db = getFirestore(app);

// Storage setup
const storage = getStorage(app);

// Export auth and db for use in your application
export { app, auth, db, functions, storage };

// Log initialization for debugging
// console.log("Firebase initialized with config: ", firebaseConfig);
// console.log("Auth instance: ", auth);
// console.log("Firestore instance: ", db);
